const layoutStyle = () => ({
  mainApp: {
    width: '100%',
    height: '100vh',
    float: 'left',
  },
  appContent: {
    width: '100%',
    float: 'left',
  },
});

export default layoutStyle;
